import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import AddProductCatalouge from '../../components/AddProducts/AddProductCatalouge'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useProductCatalogue } from '../../hooks/Features/useProductCatalogue'
import { ROUTES } from '../../shared/constants'
import AddProductCatalogue from '../AddProductCatalogue'

export default function EditProductCatalogue() {
  const params = useParams()
  const { getProductCatalogue, catalog } = useProductCatalogue()
  const { editProductCatalogue } = useProductCatalogue()
  const [productCatalogue, setProductCatalogue] = useState({
    image: '',
    name: '',
    description: '',
    pdf: '',
    active: '',
  })

  useEffect(() => {
    getProductCatalogue({ productCatalougeId: params.productCatalougeId })
  }, [params.productCatalougeId])

  useEffect(() => {
    if (catalog) {
      setProductCatalogue({
        ...productCatalogue,
        image: catalog.image,
        name: catalog.name,
        description: catalog.description,
        pdf: catalog.file,
        active: catalog.active,
      })
    }
  }, [catalog])
  const handleProductCatelogue = () => {
    editProductCatalogue({
      ...productCatalogue,
      productCatalougeId: params.productCatalougeId,
    })
  }
  return (
    <>{!catalog ? <Loader /> : <AddProductCatalogue catalog={catalog} />}</>
    // <Layout heading="Catalog" heading2="Edit" url1={ROUTES.PRODUCT_CATALOGUE} none>
    //   {!catalog ? (
    //     <Loader />
    //   ) : (
    //     <HeaderTabLayout
    //       heading={catalog && catalog.name}
    //       content={
    //         <AddProductCatalouge
    //           state={productCatalogue}
    //           setState={setProductCatalogue}
    //           edit={catalog ? true : false}
    //         />
    //       }
    //       redirect={ROUTES.PRODUCT_CATALOGUE}
    //       text="Update"
    //       addContent={handleProductCatelogue}
    //     />
    //   )}
    // </Layout>
  )
}
